import { Criteria, Decorators, EntityGrid, Fluent, ListRequest, UploadHelper } from "@serenity-is/corelib";
import { DocumentLinkDialog } from "./DocumentLinkDialog";
import { DocumentsService } from "@/ServerTypes/Cemdo";
import { DocumentLinkRow } from "@/ServerTypes/Default/DocumentLinkRow";
import { DocumentLinkColumns } from "@/ServerTypes/Default/DocumentLinkColumns";
import { DocumentLinkService } from "@/ServerTypes/Default/DocumentLinkService";

@Decorators.registerEditor('Profis.Default.DocumentLinkGrid')
export class DocumentLinkGrid extends EntityGrid<DocumentLinkRow, any> {
    protected getColumnsKey() { return DocumentLinkColumns.columnsKey; }
    protected getDialogType() { return DocumentLinkDialog; }
    protected getIdProperty() { return DocumentLinkRow.idProperty; }
    protected getInsertPermission() { return DocumentLinkRow.insertPermission; }
    protected getLocalTextPrefix() { return DocumentLinkRow.localTextPrefix; }
    protected getService() { return DocumentLinkService.baseUrl; }

    protected _documentId: number;

    public get DocumentId(): number {
        return this._documentId;
    }

    addButtonClick() {
        this.editItem({
            Document1Id: this.DocumentId
        });
    }

    getButtons() {
        var buttons = super.getButtons();
        return buttons;
    }

    getColumns() {
        var columns = super.getColumns();

        columns.splice(2, 0, {
            field: 'EditLink1',
            name: '',
            width: 16,
            cssClass: 'align-center',
            format: ctx => {
                var item = ctx.item as DocumentLinkRow;
                if (item.Document1IsLocked ||
                    !Cemdo.DocumentManagement.isEditableOfficeDocument(item.Document1Filename))
                    return "";

                return `<a href="javascript:;" class="inline-action edit-document1"><i class="fa fa-pencil-square-o text-green" title="Edit Document"></i></a>`;
            }
        });
        columns.splice(3, 0, {
            field: 'DownloadLink1',
            name: '',
            width: 16,
            cssClass: 'align-center',
            format: ctx => {
                var item = ctx.item as DocumentLinkRow;
                var url = UploadHelper.dbFileUrl(item.Document1File);
                return `<a href="${url}" target='_blank' download><i class="fa fa-download"></i></a>`;
            }
        });

        columns.splice(5, 0, {
            field: 'EditLink2',
            name: '',
            width: 16,
            cssClass: 'align-center',
            format: ctx => {
                var item = ctx.item as DocumentLinkRow;
                if (item.Document2IsLocked ||
                    !Cemdo.DocumentManagement.isEditableOfficeDocument(item.Document2Filename))
                    return "";

                return `<a href="javascript:;" class="inline-action edit-document2"><i class="fa fa-pencil-square-o text-green" title="Edit Document"></i></a>`;
            }
        });
        columns.splice(6, 0, {
            field: 'DownloadLink2',
            name: '',
            width: 16,
            cssClass: 'align-center',
            format: ctx => {
                var item = ctx.item as DocumentLinkRow;
                var url = UploadHelper.dbFileUrl(item.Document2File);
                return `<a href="${url}" target='_blank' download><i class="fa fa-download"></i></a>`;
            }
        });
        return columns;
    }

    protected onClick(e: Event, row: number, cell: number) {
        super.onClick(e, row, cell);

        if (Fluent.isDefaultPrevented(e))
            return;

        var item = this.itemAt(row) as DocumentLinkRow;
        var target = Fluent(e.target);

        // if user clicks "i" element, e.g. icon
        if (target.parent().hasClass('inline-action') ||
            target.parent().hasClass("folder-item"))
            target = target.parent();

        if (target.hasClass('inline-action')) {
            e.preventDefault();

            if (target.hasClass('edit-document1')) {
                DocumentsService.FileAccess({
                    EntityId: item.Document1Id,
                    Writable: true
                }, response => Cemdo.DocumentManagement.editOfficeDocument(response.RelativeUrl));
            }
            if (target.hasClass('edit-document2')) {
                DocumentsService.FileAccess({
                    EntityId: item.Document2Id,
                    Writable: true
                }, response => Cemdo.DocumentManagement.editOfficeDocument(response.RelativeUrl));
            }
        }
    }

    protected getIncludeColumns(columns) {
        super.getIncludeColumns(columns);
        columns[DocumentLinkRow.Fields.Document1File] = true;
        columns[DocumentLinkRow.Fields.Document2File] = true;
    }


    public set DocumentId(value: number) {
        this._documentId = value;
        this.refresh();
    }

    getGridCanLoad() {
        return super.getGridCanLoad() && !!this.DocumentId;
    }

    protected onViewSubmit() {
        if (!super.onViewSubmit())
            return false;

        var request = this.view.params as ListRequest;
        request.Criteria = Criteria.and(request.Criteria, Criteria.or([[DocumentLinkRow.Fields.Document1Id], '=', this.DocumentId], [[DocumentLinkRow.Fields.Document2Id], '=', this.DocumentId]));

        return true;
    }
}